import { buildNaturalCaptureLongNoteRows } from './importLogsLongNoteParsing';
import { normalizeImportedLongNoteReviewRows } from './importLogsReviewNormalization';

export const runLongNoteEmailAdapter = (adapterInput = {}, {
  defaultDate = new Date(),
  childName = null,
  enableDomainBoundarySplit = false,
  parserMode = 'long_note_email',
  sourceMode = 'long_note_email',
  inputMode = 'import',
  rawText = '',
} = {}) => {
  const normalizedInput = String(adapterInput.text || '').trim();
  const parsedRows = buildNaturalCaptureLongNoteRows(normalizedInput, {
    defaultDate,
    childName,
    enableDomainBoundarySplit,
    parserMode,
    sourceMode,
    inputMode,
    rawText: String(rawText || normalizedInput || '').trim(),
  });

  const rows = normalizeImportedLongNoteReviewRows(parsedRows, {
    parserMode,
    sourceMode,
    inputMode,
    rawText: String(rawText || normalizedInput || '').trim(),
  });
  const categoryComparisons = [];
  const resolvedRows = rows;

  return {
    rows: resolvedRows,
    debug: {
      parserUsed: 'natural_capture_long_note_adapter',
      parserMode,
      sourceMode,
      inputMode,
      adapterMode: 'long_note_email',
      inputType: 'long_note_review',
      detectedShape: adapterInput.shapeHint || 'long_note_email',
      chunkPlanSource: 'splitNaturalCaptureLongNoteBlocks',
      rawTextLength: String(rawText || normalizedInput || '').length,
      rowCount: resolvedRows.length,
      categoryComparisons,
      decisionAudit: categoryComparisons.map((decision, index) => ({
        index,
        originalCategory: decision?.originalCategory || null,
        proposedCategory: decision?.proposedCategory || null,
        finalCategory: decision?.finalCategory || null,
        promotionApplied: Boolean(decision?.promotionApplied),
        promotionReason: decision?.promotionReason || '',
        adapterMode: inputMode,
        detectedShape: adapterInput.shapeHint || 'long_note_email',
        fallbackReason: decision?.reason?.[0] || '',
      })),
    },
  };
};
